var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoorLighter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "595.281px",
    height: "396.85px",
    viewBox: "0 0 595.281 396.85",
    enableBackground: "new 0 0 595.281 396.85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "door",
    fill: "#DDDDDD",
    d: "M410.285,61.06L286.269,50.725c-6.76-0.525-12.668,4.523-13.202,11.283h-0.229v260.433h0.229 c0.534,6.759,6.442,11.808,13.202,11.281l124.016-10.334c6.428-0.536,11.371-5.909,11.371-12.359V73.419 C421.656,66.969,416.712,61.596,410.285,61.06z M310.042,210.826c-6.849,0-12.401-5.552-12.401-12.401s5.553-12.401,12.401-12.401 c6.85,0,12.401,5.552,12.401,12.401S316.891,210.826,310.042,210.826z M198.428,62.008h49.606v24.803h-49.606v210.827h49.606v24.803 h-49.606c-13.691-0.018-24.786-11.112-24.803-24.803V86.811C173.642,73.12,184.737,62.026,198.428,62.008z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorLighter);
export default __webpack_public_path__ + "static/media/door_lighter.975fffad5b23ad36ac366977f0f266f1.svg";
export { ForwardRef as ReactComponent };